export const orderStatusDefaultTemplate = `lexical:
<p style="text-align: center;">
  <img src="https://api.wapro-programy.pl/Media/Default/Pictures/97A67481.png" style="display: block; margin-left: auto; margin-right: auto;" />
</p>

<p style="margin-top: 1em;">&nbsp;</p>

<p style="text-align: center; margin: 2em 0 1em 0;">
  <strong style="font-size: 2em;">Aktualizacja statusu zamówienia</strong>
</p>

<p style="text-align: center; margin: 0 0 2em 0;">
  Zamówienie <strong>{numer_zamowienia}</strong> zmieniło status na <strong>{zamowienie_status}</strong>.
</p>

<p style="text-align: center;">
    <table style="border-collapse: collapse; border-spacing: 0; width: auto; table-layout: auto;">
    <tbody>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Numer zamówienia:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{numer_zamowienia}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Zamawiający:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{zamawiajacy_nazwa_firmy_imie_nazwisko}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Data:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{data_godzina_zamowienia}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Kwota do zapłaty:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p><strong>{zamowienie_wartosc_brutto}</strong></p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma płatności:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{forma_platnosci}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma dostawy:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{forma_dostawy}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Adres dostawy:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p>{adres_dostawy}</p></td>
        </tr>
        <tr>
            <td style="padding: 0.5em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Aktualny status:</strong></p></td>
            <td style="padding: 0.5em 1em; vertical-align: top;"><p><strong>{zamowienie_status}</strong></p></td>
        </tr>
    </tbody>
    </table>
</p>

<p style="margin-top: 2em;">&nbsp;</p>

<p style="margin: 2em 0 1em 0;">
  <strong>Zamówione produkty</strong>
</p>

<p style="margin: 0 0 2em 0;">
  {tabela_zamowionych_produktow}
</p>

<p style="text-align: center; font-size: 1em; color: #666;">
  Jeżeli posiadasz konto w naszym sklepie, zaloguj się, aby śledzić stan realizacji zamówienia.
</p>
`;